import styles from './StatsBar.module.scss';
import { useSelector } from 'react-redux';
import { selectScenarioOneStats } from 'selectors/selectors';
import {
    checkNullReturnZero,
    formatNumber2DPStringIfNotZeroOrHundred
} from 'utils/common';

const ScenarioOneStats = () => {
    const scenarioOneStats = useSelector(selectScenarioOneStats);
    const { totalOutliers, percentOutliers } = {
        ...scenarioOneStats
    };
    return (
        <>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(totalOutliers)}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            percentOutliers
                        )}
                    </div>
                </div>
                <div className={styles.description}>S1 Outliers</div>
            </div>
        </>
    );
};

export default ScenarioOneStats;
